/**
 * Permite eliminar informacion de las cookies del navegador segun el cname
 * @param cname identificador de las cookies
 * @returns 
 */
export function deleteCookies(cname: string){
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if(c.indexOf(name) == 0 && (name.length != c.length)) {
      return true;
    }
  }
  return false;
}

/**
* @description Permite obtener la diferencia de dias entre 2 fechas
* @param firstDate fecha 1
* @param lastDate fecha 2
* @returns {number} cantidad de dias de diferencia
*/
export function diffDays(firstDate: Date, lastDate: Date = new Date()) {
  const milisegundosTranscurridosEntreFechas = (inicio: string | Date, fin: string | Date) => {
    return new Date(fin).getTime() - new Date(inicio).getTime();
  }
  const tiempoTranscurridoEnDias = (diferenciaEnMilisegundos: number) =>{
    return diferenciaEnMilisegundos / (1000*60*60*24);
  }
  const tiempoTranscurridoPreciso = (diferenciaEnMilisegundos: number) => {
    const diasEnUnAño = 365.25;
    const diasEnUnMes = 30.437;
    const milisegundosEnUnSegundo = 1000;
    const milisegundosEnUnMinuto = milisegundosEnUnSegundo * 60;
    const milisegundosEnUnaHora = milisegundosEnUnMinuto * 60;
    const milisegundosEnUnDia = milisegundosEnUnaHora * 24;
    const milisegundosEnUnMes = milisegundosEnUnDia * diasEnUnMes;
    const milisegundosEnUnAño = milisegundosEnUnDia * diasEnUnAño;
    const años = Math.floor(diferenciaEnMilisegundos / milisegundosEnUnAño);
    diferenciaEnMilisegundos -= años * milisegundosEnUnAño;
    const meses = Math.floor(diferenciaEnMilisegundos / milisegundosEnUnMes);
    diferenciaEnMilisegundos -= meses * milisegundosEnUnMes;
    const dias = Math.floor(diferenciaEnMilisegundos / milisegundosEnUnDia);
    diferenciaEnMilisegundos -= dias * milisegundosEnUnDia;
    const horas = Math.floor(diferenciaEnMilisegundos / milisegundosEnUnaHora);
    diferenciaEnMilisegundos -= horas * milisegundosEnUnaHora;
    const minutos = Math.floor(diferenciaEnMilisegundos / milisegundosEnUnMinuto);
    diferenciaEnMilisegundos -= minutos * milisegundosEnUnMinuto;
    const segundos = Math.floor(diferenciaEnMilisegundos / milisegundosEnUnSegundo);
    diferenciaEnMilisegundos -= segundos * milisegundosEnUnSegundo;
    return { años, meses, dias, horas, minutos, segundos };
  }
  const diferenciaEnMilisegundos = milisegundosTranscurridosEntreFechas(lastDate, firstDate);
  const diferenciaPrecisa = tiempoTranscurridoPreciso(diferenciaEnMilisegundos);
  const diferenciaEnDias = tiempoTranscurridoEnDias(diferenciaEnMilisegundos);
  return {
    diferenciaEnMilisegundos
    , diferenciaPrecisa
    , diferenciaEnDias
  }
}